import https from 'hub-http/clients/apiClient';
const BASE_URL = 'collected-forms/v1/forms';
const ESP_URL = '/esp-sync/v1/form-subscriptions';
export function getCollectedForm(guid) {
  return https.get(`${BASE_URL}/${guid}`);
}
export function deleteCollectedForm(guid) {
  return https.delete(`${BASE_URL}/${guid}`);
}
export function getSubscriptions(guid) {
  return https.get(`${ESP_URL}/${guid}`);
}
export function updateSubscriptions(guid, subscriptions) {
  return https.put(`${ESP_URL}/${guid}`, {
    data: subscriptions
  });
}